import { all, fork, put, call, select, takeLatest } from 'redux-saga/effects';
import * as authTypes from './authTypes';
import * as authActions from './authActions';
import { setAppLoading } from 'src/modules/app/store/appActions';
import storage from 'src/utils/storageUtils';
import { push } from 'redux-first-history';
import { authPages } from 'src/config';
import { getClinics, loginStaff, getProfile, sendOtp, loginWithOtp } from '../api/authApi';

function* handleLogin({ data, resolve, reject }) {
  try {
    const res = yield call(loginStaff, {
      email: data.email,
      password: data.password,
    });

    storage.set('TOKEN', res.token);

    yield put(authActions.restoreSession());
    resolve(true);
  } catch (error) {
    console.log('Login error:', error);
    storage.del('TOKEN');
    reject(error);
  }
}

function* handleLogout() {
  storage.del('TOKEN');
  yield put(push('/auth/login'));
}

function* handleGetClinics(action) {
  const { token, resolve, reject } = action.payload || {};

  try {
    const response = yield call(getClinics);
    const clinics = response?.data || [];

    yield put(authActions.getClinicSuccess(clinics));

    if (clinics.length > 0) {
      const savedClinicId = localStorage.getItem('selectedClinicId');
      const clinic = clinics.find((c) => c.id === savedClinicId) || clinics[0];
      localStorage.setItem('selectedClinicId', clinic.id);
      localStorage.setItem('selectedClinic', JSON.stringify(clinic));
      yield put(authActions.setSelectedClinic(clinic));
    }

    const pathname = yield select((state) => state.router?.location?.pathname || '');
    const staffEmail = (storage.get('STAFFEMAIL') || localStorage.getItem('staffEmail') || '').toLowerCase();
    const isSanginiOnly = staffEmail.includes('sangini') || staffEmail === 'tapan@sanginihospital.com';

    if (authPages.includes(pathname) || pathname === '/auth/login' || pathname === '' || pathname === '/select-clinic') {
      if (isSanginiOnly) {
        yield put(push('/appointments'));
      } else {
        yield put(push('/tasks'));
      }
    }

    if (resolve) resolve(response);
  } catch (error) {
    yield put(authActions.getClinicFailure(error));
    if (reject) reject(error);
  }
}



function* restoreSession() {
  try {
    console.log('I AM HERE 03');
    const token = storage.get('TOKEN');
    if (token && token !== '') {
      const res = yield call(getProfile);
      console.log('Profile data:', res);

      if (res.staff) {
        yield put(authActions.setAuthStaff(res.staff));
        storage.set('STAFFNAME', res.staff.name);
        if (res.staff.email) {
          storage.set('STAFFEMAIL', res.staff.email);
          localStorage.setItem('staffEmail', res.staff.email);
        }
        if (res.staff.role) {
          storage.set('STAFFROLE', res.staff.role);
          localStorage.setItem('staffRole', res.staff.role);
        }
        yield put(authActions.getClinicRequest(token));
      } else {
        yield put(push('/auth/login'));
      }
    } else {
      yield put(push('/auth/login'));
    }
    yield put(setAppLoading(false));
  } catch (error) {
    console.log('Session restore error:', error);
    yield put(push('/auth/login'));
    yield put(setAppLoading(false));
  }
}




function* sendOtpSaga(action) {
  try {
    console.log('Saga: Sending OTP with Payload:', action.payload);
    const { email, resolve, reject } = action.payload;
    yield call(sendOtp, { email });
    console.log('OTP Sent Successfully');
    yield put({ type: authTypes.SEND_OTP_SUCCESS });
    resolve();
  } catch (error) {
    console.error('Error in sendOtpSaga:', error);
    yield put({ type: authTypes.SEND_OTP_FAILURE, payload: error });
    action.payload.reject(error);
  }
}

function* loginWithOtpSaga(action) {
  try {
    const { data, resolve, reject } = action.payload;
    const response = yield call(loginWithOtp, data);

    const token = response?.token;
    if (!token) {
      throw new Error('Token not found in response');
    }

    yield put({ type: authTypes.LOGIN_WITH_OTP_SUCCESS, payload: token });
    storage.set('TOKEN', token);
    yield put(authActions.restoreSession());

    resolve(true);
  } catch (error) {
    console.error('Error in sendOtpSaga:', error);
    yield put({ type: authTypes.LOGIN_WITH_OTP_FAILURE, payload: error });
    action.payload.reject(error);
  }
}

export function* watchSagas() {
  yield takeLatest(authTypes.LOGIN, handleLogin);
  yield takeLatest(authTypes.RESTORE_SESSION, restoreSession);
  yield takeLatest(authTypes.LOGOUT, handleLogout);
  yield takeLatest(authTypes.SEND_OTP_REQUEST, sendOtpSaga);
  yield takeLatest(authTypes.LOGIN_WITH_OTP_REQUEST, loginWithOtpSaga);
  yield takeLatest(authTypes.GET_CLINIC_REQUEST, handleGetClinics)
}

export default function* runSagas() {
  yield all([fork(watchSagas)]);
}
